import { render, staticRenderFns } from "./MarkdownPage.vue?vue&type=template&id=1c40fea0&lang=pug&"
import script from "./MarkdownPage.vue?vue&type=script&lang=js&"
export * from "./MarkdownPage.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports